import { CharactersTypes } from '../constants/charactersConstants';

const setCharacters = (chars) => ({
    type: CharactersTypes.SET_CHARACTERS,
    chars
});

const updateCharacters = (chars) => ({
    type: CharactersTypes.UPDATE_CHARACTERS,
    chars
});

const updateChar = (id, char, preventSelfUpdate) => ({
    type: CharactersTypes.UPDATE_CHAR,
    id,
    char,
    preventSelfUpdate: preventSelfUpdate || false
});

const removeChar = (id, preventSelfUpdate) => ({
    type: CharactersTypes.REMOVE_CHAR,
    id,
    preventSelfUpdate: preventSelfUpdate || false,
});

const removeMultiChar = (ids, preventSelfUpdate) => ({
    type: CharactersTypes.REMOVE_MULTI_CHAR,
    ids,
    preventSelfUpdate: preventSelfUpdate || false,
});

const updateChildrenChar = (parentId, chars, preventSelfUpdate) => ({
    type: CharactersTypes.UPDATE_CHILDREN_CHAR,
    parentId,
    chars,
    preventSelfUpdate: preventSelfUpdate || false
});

const selectChar = (charId) => ({
    type: CharactersTypes.SELECT_CHAR,
    charId
});

const updateToken = (token) => ({
    type: CharactersTypes.UPDATE_TOKEN,
    token
});

const deleteToken = (token) => ({
    type: CharactersTypes.DELETE_TOKEN,
    token
});

const setSheetTemplate = (template) => ({
    type: CharactersTypes.SET_SHEET_TEMPLATE,
    template
});

const setSheetFormOpened = (opened, charId) => ({
    type: CharactersTypes.SET_SHEET_FORM_OPENED,
    opened,
    charId
});
const setSheetValue = (sheet) => ({
    type: CharactersTypes.SET_SHEET_VALUES,
    sheet,
});

const addSheetShortcut = (sheet) => ({
    type: CharactersTypes.ADD_SHEET_SHORTCUT,
    sheet
});

const removeSheetShortcut = (sheetId) => ({
    type: CharactersTypes.REMOVE_SHEET_SHORTCUT,
    sheetId
});

const setOpenedDetail = (opened, detailId) => ({
    type: CharactersTypes.SET_OPENED_DETAIL,
    opened,
    detailId
});

const seekForToken = (charId) => ({
    type: CharactersTypes.SEEK_FOR_TOKEN,
    charId
});


export default {
    setCharacters,
    updateCharacters,
    updateChar,
    removeChar,
    removeMultiChar,
    updateChildrenChar,
    selectChar,
    updateToken,
    deleteToken,
    setSheetTemplate,
    setSheetFormOpened,
    setSheetValue,
    addSheetShortcut,
    removeSheetShortcut,
    setOpenedDetail,
    seekForToken
};